import { keepPreviousData, useInfiniteQuery, useQuery } from '@tanstack/react-query';
import API, { workApiUrl as WorkQK, branchesApiUrl as BranchQK, quizApiUrl as QuizQK } from './api';
import { ResponseType } from 'src/constants/data';
import { WorkFilters } from 'src/types';

export const useGetVacancies = (params: Partial<WorkFilters>) => {
  return useInfiniteQuery({
    queryKey: [WorkQK, ResponseType.List, params],
    initialPageParam: 1,
    queryFn: ({ pageParam = 1 }) => API.search({ ...params, page: pageParam }),
    getNextPageParam: (lastPage, allPages) => {
      const totalPages = Math.ceil(lastPage?.totalCount / (params.limit ?? 15));
      const currentPage = allPages.length;
      return currentPage < totalPages ? currentPage + 1 : undefined;
    },
    placeholderData: keepPreviousData
  });
};

export const useGetTags = () => {
  return useQuery({
    queryKey: [WorkQK + '/tags', ResponseType.List],
    queryFn: () => API.getTags(),
    placeholderData: keepPreviousData
  });
};

export const useGetBranches = () => {
  return useQuery({
    queryKey: [BranchQK, ResponseType.List],
    queryFn: () => API.getBranches(),
    placeholderData: keepPreviousData
  });
};

export const useGetQuiz = (params: { id: string }) => {
  return useQuery({
    queryKey: [QuizQK, ResponseType.List, params],
    queryFn: () => API.getQuestions(params),
    placeholderData: keepPreviousData,
    enabled: !!params.id
  });
};
